class CartAddAnotherClipHandler {
    constructor() {
        this.cartObserver = null;
        this.init();
    }
    init() {
        document.body.addEventListener("click", this.handleButtonClick.bind(this));
        this.setupCartObserver();
    }
    async handleButtonClick(event) {
        const button = event.target.closest(".cart-item-group__add-another");
        if (!button) return;
        event.preventDefault();
        try {
            const configId = button.dataset.configId;
            const frameBrand = button.dataset.frameBrand;
            const frameModel = button.dataset.frameModel;
            const frameProduct = button.dataset.frameProduct;
            if (!configId) {
                console.error("[CartAddAnotherClipHandler] Missing config ID");
                alert("Error: Configuration data missing. Please try again.");
                return;
            }
            const response = await fetch("/cart.js");
            if (!response.ok) {
                throw new Error("Failed to fetch cart data");
            }
            const cartData = await response.json();
            const inThisConfig = item => item.properties["_Config ID"] === configId || item.properties["_Configuration ID"] === configId;
            let firstClip = cartData.items.find(item => {
                if (!inThisConfig(item)) return false;
                const clipSequence = item.properties["_Clip Sequence"];
                return !clipSequence || clipSequence === "1" || parseInt(clipSequence) === 1;
            });
            if (!firstClip) {
                firstClip = cartData.items.filter(inThisConfig).sort((a, b) => parseInt(a.properties["_Clip Sequence"] || "999", 10) - parseInt(b.properties["_Clip Sequence"] || "999", 10))[0];
            }
            if (!firstClip) {
                console.error("[CartAddAnotherClipHandler] First clip not found in cart for config:", configId);
                console.error("[CartAddAnotherClipHandler] Available cart items:", cartData.items.map(i => ({
                    title: i.title,
                    configId: i.properties["_Config ID"] || i.properties["_Configuration ID"],
                    sequence: i.properties["_Clip Sequence"]
                })));
                alert("Error: Could not find clip configuration. Please try again.");
                return;
            }
            const frameData = {
                frameChoice: firstClip.properties["_Frame Choice Key"] || firstClip.properties["_Frame Choice"] || "own-frame-own-lenses",
                frameProduct: frameProduct || "",
                frameBrand: frameBrand || "",
                frameModel: frameModel || "",
                frameVariantId: firstClip.properties["_Frame Variant ID"] ? parseInt(firstClip.properties["_Frame Variant ID"]) : null,
                frameVariantTitle: firstClip.properties["_Frame Color"] || null,
                nativeLensType: firstClip.properties["_Prescription Lens Type"] || firstClip.properties["_Native Lens Type"] || "single-vision",
                nativeLensFeature: firstClip.properties["_Prescription Lens Feature"] || firstClip.properties["_Native Lens Feature"] || "standard",
                nativeLensMaterial: firstClip.properties["_Prescription Lens Material"] || firstClip.properties["_Native Lens Material"] || "standard",
                prescription: firstClip.properties["_Prescription"] || null,
                orderSource: firstClip.properties["_Order Source"] || null,
                originalOrder: firstClip.properties["_Original Order"] || null,
                rxUploadToken: firstClip.properties["_Rx Upload Token"] || null,
                rxUploadFilename: firstClip.properties["_Rx Upload Filename"] || null,
                prescriptionStatus: firstClip.properties["_Prescription Status"] || null
            };
            localStorage.setItem("secondClipFrameData", JSON.stringify(frameData));
            localStorage.setItem("isBuilding2ndClip", "true");
            localStorage.setItem("jumpToStep", "3");
            button.textContent = "Loading...";
            button.disabled = true;
            window.location.href = "/pages/order-flow";
        } catch (error) {
            console.error("[CartAddAnotherClipHandler] Error:", error);
            alert("Error loading clip data. Please try again.");
            if (button) {
                button.textContent = button.dataset.originalText || "Add Another Clip";
                button.disabled = false;
            }
        }
    }
    setupCartObserver() {
        const cartDrawer = document.querySelector(".cart-drawer-items");
        if (!cartDrawer) {
            return;
        }
        this.cartObserver = new MutationObserver(mutations => {
            const hasChanges = mutations.some(mutation => mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0);
            if (hasChanges) {
                const buttons = document.querySelectorAll(".cart-item-group__add-another");
            }
        });
        this.cartObserver.observe(cartDrawer, {
            childList: true,
            subtree: true
        });
    }
    destroy() {
        if (this.cartObserver) {
            this.cartObserver.disconnect();
            this.cartObserver = null;
        }
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        window.cartAddAnotherClipHandler = new CartAddAnotherClipHandler;
    });
} else {
    window.cartAddAnotherClipHandler = new CartAddAnotherClipHandler;
}

window.CartAddAnotherClipHandler = CartAddAnotherClipHandler;